var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-editor",class:_vm.editorClasses},[(!_vm.readonly)?_c('v-toolbar',{staticClass:"markdown-editor__toolbar",attrs:{"dense":"","flat":""}},[_c('v-btn-toggle',{staticClass:"mr-2",attrs:{"dense":"","multiple":"","value":_vm.activeMarks}},[_c('v-btn',{attrs:{"small":"","value":'bold'},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleBold()
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-bold")])],1),_c('v-btn',{attrs:{"small":"","value":'italic'},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleItalic()
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-italic")])],1),_c('v-btn',{attrs:{"small":"","value":'strike'},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleStrike()
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-strikethrough")])],1)],1),_c('v-btn-toggle',{staticClass:"mr-2",attrs:{"dense":"","value":_vm.activeBlock}},[_c('v-btn',{attrs:{"small":"","value":"paragraph"},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .setParagraph()
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-paragraph")])],1),_c('v-btn',{attrs:{"small":"","value":"heading1"},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleHeading({ level: 1 })
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-header-1")])],1),_c('v-btn',{attrs:{"small":"","value":"heading2"},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleHeading({ level: 2 })
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-header-2")])],1),_c('v-btn',{attrs:{"small":"","value":"heading3"},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleHeading({ level: 3 })
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-header-3")])],1)],1),_c('v-btn-toggle',{attrs:{"dense":"","value":_vm.activeList}},[_c('v-btn',{attrs:{"small":"","value":"bulletList"},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleBulletList()
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-list-bulleted")])],1),_c('v-btn',{attrs:{"small":"","value":"orderedList"},on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleOrderedList()
            .run()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-format-list-numbered")])],1)],1)],1):_vm._e(),_c('editor-content',{staticClass:"markdown-editor__content",attrs:{"editor":_vm.editor}}),(_vm.hasError)?_c('div',{staticClass:"markdown-editor__error"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }